import { useState } from "react";

export function usePagination() {
  const [page, setPage] = useState<{ page: number; on: boolean }>({ page: 1, on: true });

  return { page, setPage };
}
